import { registerPlugin } from '@capacitor/core'
import type { PluginListenerHandle } from '@capacitor/core'

export interface PoseLandmark {
  x: number
  y: number
  confidence: number
}

export interface PoseUpdateEvent {
  poseDetected: boolean
  landmarkCount: number
  similarityScore: number
  isMatch: boolean
  comparedLandmarks: number
  guidanceInstruction: string
  guidanceDirection: 'left' | 'right' | 'forward' | 'back' | 'up' | 'down' | 'still'
  guidanceSeverity: 'minor' | 'major'
  landmarks: Record<string, PoseLandmark>
}

export interface CaptureResult {
  photoBase64: string
  poseSnapshotJson?: string
}

export interface PresentCameraResult {
  cancelled: boolean
  /** iOS Photos library local identifier (e.g., "ABC123-456/L0/001") */
  photoLocalIdentifier?: string
  /** Pose snapshot JSON for reference matching */
  poseSnapshotJson?: string
}

interface PoseDetectionPlugin {
  /** Present the native SwiftUI camera view as a fullscreen modal. */
  presentCamera(): Promise<PresentCameraResult>
  startSession(options?: { cameraPosition?: 'front' | 'back' }): Promise<void>
  stopSession(): Promise<void>
  capturePhoto(): Promise<CaptureResult>
  setReferencePose(options: { poseSnapshotJson: string }): Promise<void>
  clearReferencePose(): Promise<void>
  addListener(
    eventName: 'poseUpdate',
    listenerFunc: (event: PoseUpdateEvent) => void
  ): Promise<PluginListenerHandle>
  addListener(
    eventName: 'error',
    listenerFunc: (event: { message: string }) => void
  ): Promise<PluginListenerHandle>
}

export const PoseDetection = registerPlugin<PoseDetectionPlugin>('PoseDetection')
